import { render, staticRenderFns } from "./AboutFinance.vue?vue&type=template&id=13df5b46&scoped=true&"
import script from "./AboutFinance.vue?vue&type=script&lang=js&"
export * from "./AboutFinance.vue?vue&type=script&lang=js&"
import style0 from "./AboutFinance.vue?vue&type=style&index=0&id=13df5b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df5b46",
  null
  
)

export default component.exports